import { AssetLibraryManager, RuntimeEngine } from '@easytwin/runtime';
import { useBindSignal } from './useBindSignal';
import { useDumbState } from './useDumbState';
import { useMainScene } from './useMainScene';

export const useGetSceneTextures = (engine: RuntimeEngine | undefined) => {
  const scene = useMainScene(engine);
  const refresh = useDumbState();
  const assetLibraryMgr = scene?.getManager(AssetLibraryManager);
  useBindSignal(assetLibraryMgr?.signals.textureListUpdated, refresh);

  return assetLibraryMgr?.getTextureListVO();
};
